import Head from 'next/head'

const CreatorHead = () => {
  return (
    <Head>
      <title key="title">我的後台｜PopDaily 波波黛莉</title>
    </Head>
  )
}

export default CreatorHead
